
    <span class="nb-badge {{positionClass}} nb-badge-{{colorClass}}">{{text}}</span>
  